"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = require("redux");
var _modalReducer = _interopRequireDefault(require("./modalReducer"));
var _chatsByRoomNameReducer = _interopRequireDefault(require("./chatsByRoomNameReducer"));
var _currentChatReducer = _interopRequireDefault(require("./currentChatReducer"));
var _currentChatPositionReducer = _interopRequireDefault(require("./currentChatPositionReducer"));
var _messagesByRoomNameReducer = _interopRequireDefault(require("./messagesByRoomNameReducer"));
var _stanzasReducer = _interopRequireDefault(require("./stanzasReducer"));
var _partnersReducer = _interopRequireDefault(require("./partnersReducer"));
var _chatUiReducer = _interopRequireDefault(require("./chatUiReducer"));
var _messageUiReducer = _interopRequireDefault(require("./messageUiReducer"));
var _variantsReducer = _interopRequireDefault(require("./variantsReducer"));
var _typingByRoomNameReducer = _interopRequireDefault(require("./typingByRoomNameReducer"));
var _chatsLoadedReducer = _interopRequireDefault(require("./chatsLoadedReducer"));
var _lastListPositionReducer = _interopRequireDefault(require("./lastListPositionReducer"));
var _renderPropsReducer = _interopRequireDefault(require("./renderPropsReducer"));
var _imageReducer = _interopRequireDefault(require("./imageReducer"));
var _walletButtonReducer = _interopRequireDefault(require("./walletButtonReducer"));
var _preDefinedMessageReducer = _interopRequireDefault(require("./preDefinedMessageReducer"));
var _keyboardReducer = _interopRequireDefault(require("./keyboardReducer"));
var _chatTabsReducer = _interopRequireDefault(require("./chatTabsReducer"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = (0, _redux.combineReducers)({
  ui: (0, _redux.combineReducers)({
    chat: _chatUiReducer["default"],
    message: _messageUiReducer["default"]
  }),
  modal: _modalReducer["default"],
  chatsByRoomName: _chatsByRoomNameReducer["default"],
  currentChat: _currentChatReducer["default"],
  currentChatPosition: _currentChatPositionReducer["default"],
  messagesByRoomName: _messagesByRoomNameReducer["default"],
  partners: _partnersReducer["default"],
  stanzas: _stanzasReducer["default"],
  variants: _variantsReducer["default"],
  typingByRoomName: _typingByRoomNameReducer["default"],
  chatsLoaded: _chatsLoadedReducer["default"],
  lastListPosition: _lastListPositionReducer["default"],
  renderProps: _renderPropsReducer["default"],
  image: _imageReducer["default"],
  walletButtons: _walletButtonReducer["default"],
  preDefinedMessage: _preDefinedMessageReducer["default"],
  keyboardState: _keyboardReducer["default"],
  chatTabs: _chatTabsReducer["default"]
});